var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {},
    [
      _c(
        "v-col",
        { attrs: { cols: "12", md: "6", lg: "5" } },
        [
          _c("ProductGallery", {
            attrs: {
              "is-loading": _vm.isLoading,
              "gallery-imgaes": _vm.productDetails.photos,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { md: "6", lg: "7" } },
        [
          _vm.isLoading
            ? [
                _c("v-skeleton-loader", {
                  staticClass: "mb-3",
                  attrs: {
                    type: "table-cell,sentences,table-cell,divider,table-cell,table-row",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? [
                _c("h1", { staticClass: "fs-21 opacity-80 mb-3 lh-1-3" }, [
                  _vm._v(" " + _vm._s(_vm.productDetails.name) + " "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex fs-12" },
                  [
                    _vm.productDetails.review_summary &&
                    _vm.generalSettings.reviews == 1
                      ? [
                          _c("span", { staticClass: "me-3 opacity-50" }, [
                            _vm._v(
                              _vm._s(
                                _vm.productDetails.review_summary.average.toFixed(
                                  2
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-rating", {
                            staticClass: "lh-1-5",
                            attrs: {
                              "background-color": "",
                              "empty-icon": "las la-star",
                              "full-icon": "las la-star active",
                              "half-icon": "las la-star half",
                              hover: "",
                              "half-increments": "",
                              readonly: "",
                              size: "12",
                              length: "5",
                              value: _vm.productDetails.review_summary.average,
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ms-3 opacity-50" }, [
                            _vm._v(
                              " (" +
                                _vm._s(
                                  _vm.productDetails.review_summary.total_count
                                ) +
                                " " +
                                _vm._s(_vm.$t("ratings")) +
                                ") "
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.generalSettings.conversation_system == 1
                      ? _c("div", { staticClass: "ms-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "primary--text pa-1 lh-1 d-flex align-center",
                              on: {
                                click: function ($event) {
                                  return _vm.showConversationDialog({
                                    status: true,
                                  })
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "la la-comment ts-02 fs-14 me-1",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fw-700" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("ask_about_this_product"))
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ConversationDialog", {
                      attrs: { product: _vm.productDetails },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "ms-2",
                          {
                            "ms-auto":
                              _vm.generalSettings.conversation_system != 1,
                          },
                        ],
                      },
                      [
                        _vm.isThisWishlisted(_vm.productDetails.id)
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "primary--text pa-1 lh-1 d-flex align-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromWishlist(
                                        _vm.productDetails.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "la la-heart ts-02 fs-14 me-1",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "fw-700" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("remove_from_wishlist"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "primary--text pa-1 lh-1 d-flex align-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addNewWishlist(
                                        _vm.productDetails.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-heart-o ts-02 fs-14 me-1",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "fw-700" }, [
                                    _vm._v(_vm._s(_vm.$t("add_to_wishlist"))),
                                  ]),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("v-divider", { staticClass: "mb-4 mt-2" }),
                _vm._v(" "),
                _vm.productDetails.brand.name
                  ? _c(
                      "v-row",
                      { staticClass: "mb-4", attrs: { align: "center" } },
                      [
                        _c("v-col", { attrs: { cols: "3", lg: "2" } }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "border pa-2 lh-0 rounded d-inline-block",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Brand",
                                      params: {
                                        brandId: _vm.productDetails.brand.id,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid h-40px",
                                    attrs: {
                                      src: _vm.productDetails.brand.logo,
                                      alt: _vm.productDetails.brand.name,
                                    },
                                    on: {
                                      error: function ($event) {
                                        return _vm.imageFallback($event)
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-col", { attrs: { cols: "9", lg: "10" } }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-flex flex-column align-baseline lh-1-3",
                            },
                            [
                              _c("span", { staticClass: "fs-12 opacity-60" }, [
                                _vm._v(_vm._s(_vm.$t("brand"))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "fw-700" }, [
                                _vm._v(_vm._s(_vm.productDetails.brand.name)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "text-reset border-bottom fs-10 opacity-60",
                                  attrs: {
                                    to: {
                                      name: "Brand",
                                      params: {
                                        brandId: _vm.productDetails.brand.id,
                                      },
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("view_other_products")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.discount > 0
                  ? _c(
                      "div",
                      { staticClass: "lh-1" },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2",
                                attrs: { cols: "3", lg: "2" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "opacity-60 fs-12" },
                                  [_vm._v(_vm._s(_vm.$t("price")))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2 d-flex align-baseline",
                                attrs: { cols: "9", lg: "10" },
                              },
                              [
                                _c(
                                  "del",
                                  [
                                    _vm.productDetails.base_price !==
                                    _vm.productDetails.highest_price
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-inline-flex align-center fs-20 fw-500 opacity-50",
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.format_price(
                                                      _vm.productDetails
                                                        .base_price
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "mx-2" },
                                                [_vm._v("-")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.format_price(
                                                      _vm.productDetails
                                                        .highest_price
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "fs-20 fw-500 opacity-60",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.format_price(
                                                    _vm.productDetails
                                                      .base_price
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.productDetails.unit
                                  ? _c(
                                      "span",
                                      { staticClass: "fs-12 opacity-50 ms-1" },
                                      [
                                        _vm._v(
                                          "/" + _vm._s(_vm.productDetails.unit)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.discount > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "discount-badge details-page ms-2",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("off")) +
                                            " " +
                                            _vm._s(_vm.discount) +
                                            "%\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2",
                                attrs: { cols: "3", lg: "2" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "opacity-60 fs-12" },
                                  [_vm._v(_vm._s(_vm.$t("discounted_price")))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2",
                                attrs: { cols: "9", lg: "10" },
                              },
                              [
                                _vm.productDetails.base_price !==
                                _vm.productDetails.highest_price
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-inline-flex align-center primary--text fs-24 fw-500",
                                        },
                                        [
                                          _c("span", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.format_price(
                                                  _vm.productDetails
                                                    .base_discounted_price
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "mx-2" }, [
                                            _vm._v("-"),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.format_price(
                                                  _vm.productDetails
                                                    .highest_discounted_price
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "primary--text fs-24 fw-500",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.format_price(
                                                _vm.productDetails
                                                  .base_discounted_price
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                _vm._v(" "),
                                _vm.productDetails.unit
                                  ? _c(
                                      "span",
                                      { staticClass: "fs-12 opacity-50 ms-1" },
                                      [
                                        _vm._v(
                                          "/" + _vm._s(_vm.productDetails.unit)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "lh-1" },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2",
                                attrs: { cols: "3", lg: "2" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "opacity-60 fs-12" },
                                  [_vm._v(_vm._s(_vm.$t("price")))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-2",
                                attrs: { cols: "9", lg: "10" },
                              },
                              [
                                _vm.productDetails.base_price !==
                                _vm.productDetails.highest_price
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-inline-flex align-center primary--text fs-24 fw-500",
                                        },
                                        [
                                          _c("span", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.format_price(
                                                  _vm.productDetails.base_price
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "mx-2" }, [
                                            _vm._v("-"),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.format_price(
                                                  _vm.productDetails
                                                    .highest_price
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "primary--text fs-24 fw-500",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.format_price(
                                                _vm.productDetails.base_price
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                _vm._v(" "),
                                _vm.productDetails.unit
                                  ? _c(
                                      "span",
                                      { staticClass: "fs-12 opacity-50 ms-1" },
                                      [
                                        _vm._v(
                                          "/" + _vm._s(_vm.productDetails.unit)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.productDetails.is_variant == 1
                  ? _c(
                      "div",
                      { staticClass: "border-top mt-4" },
                      _vm._l(
                        _vm.productDetails.variation_options,
                        function (variation_option, i) {
                          return _c(
                            "v-row",
                            { key: i, staticClass: "mt-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", lg: "2" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "opacity-60 fs-12" },
                                    [_vm._v(_vm._s(variation_option.name))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "9", lg: "10" },
                                },
                                _vm._l(
                                  variation_option.values,
                                  function (value, j) {
                                    return _c(
                                      "label",
                                      {
                                        key: j,
                                        staticClass:
                                          "daon-megabox ps-0 me-2 d-inline-flex",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.chooseOptions[i],
                                              expression: "chooseOptions[i]",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: `option_${variation_option.id}`,
                                          },
                                          domProps: {
                                            value:
                                              variation_option.id +
                                              ":" +
                                              value.id,
                                            checked: _vm._q(
                                              _vm.chooseOptions[i],
                                              variation_option.id +
                                                ":" +
                                                value.id
                                            ),
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                return _vm.$set(
                                                  _vm.chooseOptions,
                                                  i,
                                                  variation_option.id +
                                                    ":" +
                                                    value.id
                                                )
                                              },
                                              _vm.optionChosen,
                                            ],
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "daon-megabox-elem rounded d-flex align-items-center justify-content-center py-1 px-3 mb-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "fw-700" },
                                              [_vm._v(_vm._s(value.name))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-row",
                  { staticClass: "mt-4 gutters-5" },
                  [
                    _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-soft-primary border border-primary rounded px-4 py-3 lh-1",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-3 d-flex align-center" },
                            [
                              _vm.stock
                                ? [
                                    _c("i", {
                                      staticClass:
                                        "las la-check green rounded-circle size-15px fs-8 white--text d-inline-flex align-center justify-center me-3",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "fs-12" }, [
                                      _vm._v(_vm._s(_vm.$t("in_stock"))),
                                    ]),
                                  ]
                                : [
                                    _c("i", {
                                      staticClass:
                                        "las la-check grey rounded-circle size-15px fs-8 white--text d-inline-flex align-center justify-center me-3",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "fs-12" }, [
                                      _vm._v(_vm._s(_vm.$t("out_of_stock"))),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "primary--text d-flex align-center",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.updateChatWindow(true)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "14.994",
                                    viewBox: "0 0 16 14.994",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group_22650",
                                        "data-name": "Group 22650",
                                        transform:
                                          "translate(11363.863 11582.499)",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          id: "Path_26196",
                                          "data-name": "Path 26196",
                                          d: "M74.137,7.123v.813a1.064,1.064,0,0,0-.028.134,6.337,6.337,0,0,1-1.656,3.743,8.251,8.251,0,0,1-5.526,2.708,8.546,8.546,0,0,1-3.661-.426.245.245,0,0,0-.262.056,10.229,10.229,0,0,1-1,.711,4.905,4.905,0,0,1-2.434.633.464.464,0,0,1-.445-.658,1.021,1.021,0,0,1,.167-.224,2.793,2.793,0,0,0,.695-2.472.533.533,0,0,0-.119-.243,6.746,6.746,0,0,1-1.4-2.394,6.1,6.1,0,0,1-.152-3.43,6.866,6.866,0,0,1,3.1-4.218A8.509,8.509,0,0,1,67.1.559a8.286,8.286,0,0,1,4.89,2.2A6.588,6.588,0,0,1,74,6.249c.062.288.093.583.139.874m-11.695-1a1.4,1.4,0,1,0,1.382,1.424,1.414,1.414,0,0,0-1.382-1.424m3.749,0a1.4,1.4,0,1,0,1.383,1.423,1.414,1.414,0,0,0-1.383-1.423m5.132,1.428A1.4,1.4,0,1,0,69.9,8.934a1.414,1.414,0,0,0,1.424-1.381",
                                          transform: "translate(-11422 -11583)",
                                          fill: "#f5a100",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "fw-500 fs-12 ms-2" }, [
                                _vm._v(_vm._s(_vm.$t("contact_admin"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "grey lighten-3 border-gray-300 rounded px-4 py-3 d-flex lh-1-3",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "19.847",
                                viewBox: "0 0 20 19.847",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Group_1226",
                                    "data-name": "Group 1226",
                                    transform: "translate(-7 -11)",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Path_3097",
                                      "data-name": "Path 3097",
                                      d: "M16.6,44.374a4.283,4.283,0,0,1-2-.723,17.011,17.011,0,0,1-1.733-1.1l-2.451.735a.445.445,0,0,1-.395-.071,9.261,9.261,0,0,1-2.986-3.853.444.444,0,0,1,.381-.614,10.4,10.4,0,0,0,3.718-.941,10.209,10.209,0,0,0,1.178-.647,11.321,11.321,0,0,1,1.654-.962,10.309,10.309,0,0,1,1.092-.4c.033-.009.089-.024.162-.045l.074-.023c.072-.022.138-.043.3-.084s.351-.088.6-.139a5.637,5.637,0,0,1,1.723-.14,3.7,3.7,0,0,1,.763.137c.33.1.625.219.911.335a8.959,8.959,0,0,0,.941.342,4.288,4.288,0,0,0,.845.153c.283.027.636.061.788.435a.886.886,0,0,1-.083.772,1.892,1.892,0,0,1-2.139.971c-.123-.019-.234-.04-.337-.064a4.139,4.139,0,0,0,.479.3,4.183,4.183,0,0,0,2.044.481h1.342a.444.444,0,0,1,.442.4,1.841,1.841,0,0,1-.18,1.047,2.5,2.5,0,0,1-2.672,1.066c-.933.726-1.875,1.408-2.8,2.029a2.986,2.986,0,0,1-1.555.607ZM12.95,41.62a.444.444,0,0,1,.265.088,16.105,16.105,0,0,0,1.813,1.166c1.155.636,1.473.619,1.626.611a2.129,2.129,0,0,0,1.107-.458c.959-.643,1.935-1.353,2.9-2.111a.442.442,0,0,1,.359-.086,1.779,1.779,0,0,0,1.916-.566.784.784,0,0,0,.059-.15h-.862a5.045,5.045,0,0,1-4.245-2.151,4.185,4.185,0,0,0-.571,0c-.08.006-.147.013-.191.018a.444.444,0,1,1-.1-.883c.053-.006.133-.015.232-.021a5.166,5.166,0,0,1,.931.021H18.2a3.4,3.4,0,0,1,.95.265,3.725,3.725,0,0,0,.927.269,1.336,1.336,0,0,0,.487.032,1.232,1.232,0,0,0,.678-.452,5.07,5.07,0,0,1-.955-.178,9.83,9.83,0,0,1-1.031-.373c-.278-.113-.541-.22-.831-.307a2.794,2.794,0,0,0-.581-.1,4.834,4.834,0,0,0-1.472.126c-.23.047-.416.092-.554.128s-.192.053-.253.072l-.085.026c-.085.025-.15.043-.176.05a9.7,9.7,0,0,0-.967.359,10.647,10.647,0,0,0-1.522.889,11.069,11.069,0,0,1-4.7,1.679,8.364,8.364,0,0,0,2.269,2.793l2.444-.733a.443.443,0,0,1,.128-.019Z",
                                      transform: "translate(0 -13.528)",
                                      fill: "#b8b8b8",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      id: "Path_3098",
                                      "data-name": "Path 3098",
                                      d: "M31,26.555H25.929a.444.444,0,0,1,0-.889h4.627V11.889H15.889V24.831a.444.444,0,1,1-.889,0V11.444A.444.444,0,0,1,15.444,11H31a.444.444,0,0,1,.444.444V26.111A.444.444,0,0,1,31,26.555Z",
                                      transform: "translate(-4.444)",
                                      fill: "#b8b8b8",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      id: "Path_3099",
                                      "data-name": "Path 3099",
                                      d: "M32.5,15.444H28.944A.444.444,0,0,1,28.5,15V11.444A.444.444,0,0,1,28.944,11H32.5a.444.444,0,0,1,.444.444V15A.444.444,0,0,1,32.5,15.444Zm-3.111-.889h2.667V11.889H29.389Z",
                                      transform: "translate(-11.944)",
                                      fill: "#b8b8b8",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ms-3" }, [
                            _c(
                              "div",
                              { staticClass: "fw-700 mb-3 text-truncate" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("estimated_delivery_time"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            Math.ceil(
                              _vm.productDetails.express_delivery_time / 24
                            ) ==
                            Math.ceil(
                              _vm.productDetails.standard_delivery_time / 24
                            )
                              ? _c("div", { staticClass: "fs-12 opacity-50" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        Math.ceil(
                                          _vm.productDetails
                                            .express_delivery_time / 24
                                        )
                                      ) +
                                      "\n                                " +
                                      _vm._s(_vm.$t("days")) +
                                      "\n                            "
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        Math.ceil(
                                          _vm.productDetails
                                            .express_delivery_time / 24
                                        )
                                      ) +
                                      "\n                                -\n                                " +
                                      _vm._s(
                                        Math.ceil(
                                          _vm.productDetails
                                            .standard_delivery_time / 24
                                        )
                                      ) +
                                      "\n                                " +
                                      _vm._s(_vm.$t("days")) +
                                      "\n                            "
                                  ),
                                ]),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _c("v-col", { attrs: { cols: "3", lg: "2" } }, [
                      _c("span", { staticClass: "opacity-60 fs-12" }, [
                        _vm._v(_vm._s(_vm.$t("quantity"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "9", lg: "10" } },
                      [
                        _c("vue-numeric-input", {
                          attrs: {
                            min: 1,
                            max: _vm.maxCartLimit,
                            step: 1,
                            align: "center",
                            size: "132px",
                          },
                          model: {
                            value: _vm.cartQuantity,
                            callback: function ($$v) {
                              _vm.cartQuantity = $$v
                            },
                            expression: "cartQuantity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.is_empty_obj(_vm.selectedVariation) &&
                Number.isInteger(_vm.cartQuantity)
                  ? _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "3", lg: "2" } }, [
                          _c("span", { staticClass: "opacity-60 fs-12" }, [
                            _vm._v(_vm._s(_vm.$t("total_price"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("v-col", { attrs: { cols: "9", lg: "10" } }, [
                          _c(
                            "span",
                            { staticClass: "primary--text fs-24 fw-600" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.format_price(
                                    _vm.selectedVariation.price *
                                      _vm.cartQuantity
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "my-5" },
                  [
                    Number.isInteger(_vm.cartQuantity)
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "grey darken-4 white--text",
                              elevation: "0",
                              block: "",
                            },
                            on: { click: _vm.addCart },
                          },
                          [_vm._v(_vm._s(_vm.$t("add_to_cart")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _c("v-col", { attrs: { cols: "3", lg: "2" } }, [
                      _c("span", { staticClass: "opacity-60 fs-12" }, [
                        _vm._v(_vm._s(_vm.$t("share"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "9", lg: "10" } },
                      [
                        _c("SocialShare", {
                          attrs: { title: _vm.productDetails.name },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }